<template>
  <div class="headers">
    <img v-if="!noBack" src="@/assets/back.png" class="back" @click="back()">
    <div class="text">{{title}}</div>
  </div>
</template>

<script>
	export default {
		props:{
			title:'',
      noBack:false,
		},
		data() {
			return {

			}
		},
		created() {

		},
		methods:{
      back(){
        this.$router.go(-1)
      }
		}
	}
</script>

<style lang="less">
  .headers{
    width: 100%;
    height: 100px;
    line-height: 100px;
    position: relative;
    text-align: center;
    background: #ffffff;
    .back{
      width: 50px;
      position: absolute;
      top: 50%;
      left: 20px;
      transform: translateY(-50%);
    }
    .text{
      font-size: 32px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header.vue